import { render, staticRenderFns } from "./pesquisaSatisfacaoChartSideBar.vue?vue&type=template&id=23cb5e41"
import script from "./pesquisaSatisfacaoChartSideBar.vue?vue&type=script&lang=js"
export * from "./pesquisaSatisfacaoChartSideBar.vue?vue&type=script&lang=js"
import style0 from "./pesquisaSatisfacaoChartSideBar.vue?vue&type=style&index=0&id=23cb5e41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports